<template>
	<div class="service">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onsyncorder()">下载售后订单</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="店铺">
							<el-option label="全部" value=""></el-option>
							<el-option :label="v.mall_name || v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.order_sn" placeholder="订单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.after_sale_id" placeholder="售后单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.after_sales_status" placeholder="订单状态">
							<el-option label="订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id"
								v-for="(v,k) in appdata.list.pdd_after_sales_status" :key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.after_sales_type" placeholder="售后状态">
							<el-option label="售后状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_after_sales_type"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.platform_order_status" placeholder="平台订单状态">
							<el-option label="平台订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_status"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>

			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column
						prop="mall_name"
						label="店铺名称"
						align="center"
						header-align="center"
						:min-width="mallNameColumnWidth"
						class-name="mall-name-column"
					>
						<template slot-scope="scope">
							<div class="mall-name-text">{{ scope.row.mall_name }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="after_sale_id"
						label="售后单号"
						align="center"
						header-align="center"
						:min-width="afterSaleIdColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.after_sale_id }}</div>
						</template>
					</el-table-column>
					<el-table-column
						:key="'order-sn-' + orderSnColumnWidth"
						prop="order_sn"
						label="订单编号"
						align="center"
						header-align="center"
						:min-width="orderSnColumnWidth"
						:width="orderSnColumnWidth"
						class-name="order-sn-column"
					>
						<template slot-scope="scope">
							<div class="order-sn-text">{{ scope.row.order_sn || '-' }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="after_sales_status_str"
						label="售后状态"
						align="center"
						header-align="center"
						:min-width="afterSalesStatusColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.after_sales_status_str }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="after_sales_type_str"
						label="售后类型"
						align="center"
						header-align="center"
						:min-width="afterSalesTypeColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.after_sales_type_str }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="order_status_str"
						align="center"
						header-align="center"
						min-width="56px"
						class-name="platform-order-status-column"
					>
						<template slot="header">
							<div class="header-wrap-3">平台订单状态</div>
						</template>
					</el-table-column>
					<el-table-column prop="order_service_status_str" label="平台售后状态" align="center" header-align="center"
						min-width="110px">
					</el-table-column>
					<el-table-column
						prop="dispute_refund_status"
						label="纠纷类型"
						align="center"
						header-align="center"
						:min-width="disputeRefundColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.dispute_refund_status }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="speed_refund_flag"
						label="极速退款"
						align="center"
						header-align="center"
						:min-width="speedRefundColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.speed_refund_flag }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="user_shipping_status" label="收货状态" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column
						prop="goods_name"
						label="商品名称"
						align="center"
						header-align="center"
						width="226px"
						class-name="goods-name-column"
					>
						<template slot-scope="scope">
							<el-popover
								v-if="scope.row.goods_name"
								trigger="hover"
								placement="top"
								width="360"
								popper-class="goods-name-popover"
							>
								<div class="goods-name-popover__content">{{ scope.row.goods_name }}</div>
								<el-button type="text" size="mini" @click="oncopy(scope.row.goods_name)">复制</el-button>
								<div slot="reference" class="goods-name-cell">{{ scope.row.goods_name }}</div>
							</el-popover>
							<span v-else class="goods-name-empty">-</span>
						</template>
					</el-table-column>
					<el-table-column prop="goods_number" label="商品数量" align="center" header-align="center"
						min-width="80px">
					</el-table-column>


					<el-table-column prop="outer_id" label="商家外部编码（sku）" align="center" header-align="center"
						min-width="160px">
					</el-table-column>
					<el-table-column prop="order_amount" label="订单金额（元）" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="refund_amount" label="退款金额（元）" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column
						prop="shipping_name"
						label="退货快递"
						align="center"
						header-align="center"
						:min-width="shippingNameColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.shipping_name }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="tracking_number"
						label="退货运单号"
						align="center"
						header-align="center"
						:min-width="trackingNumberColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.tracking_number }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="create_time_str"
						label="售后创建时间"
						align="center"
						header-align="center"
						:min-width="createTimeColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.create_time_str }}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="update_time_str"
						label="更新时间"
						align="center"
						header-align="center"
						:min-width="updateTimeColumnWidth"
						class-name="adapt-text-column"
					>
						<template slot-scope="scope">
							<div class="adapt-text">{{ scope.row.update_time_str }}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="80px">
						<template slot-scope="scope">
							<div class="operation_i">
								<div v-if="scope.row.trade_no">
									<span @click="onservice(scope.row.trade_no)">去处理</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="售后订单下载" :visible.sync="show" width="650px" :before-close="onclose4">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm2" :model="ruleForm2" :rules="rules" label-width="80px">
					<el-form-item label="店铺" prop="shop_id" class="item">
						<el-select v-model="ruleForm2.shop_id" placeholder="请选择店铺">
							<el-option :label="v.mall_name || v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始日期" class="item">
						<el-date-picker
							v-model="ruleForm2.btime"
							type="date"
							placeholder="默认当天"
							value-format="yyyy-MM-dd"
							clearable
							:picker-options="btimePickerOptions"
						/>
					</el-form-item>
					<el-form-item label="结束日期" class="item">
						<el-date-picker
							v-model="ruleForm2.etime"
							type="date"
							placeholder="默认当天"
							value-format="yyyy-MM-dd"
							clearable
							:picker-options="etimePickerOptions"
						/>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose4">取消</el-button>
				<el-button type="primary" @click="onsubxz()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'pddservice',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 100,
				total: 0,
				filtershow: true,
				show: false,
				formfilter: {
					shop_id: "",
					order_sn: "",
					after_sale_id: "",
					after_sales_status: "",
					after_sales_type: "",
					platform_order_status: ""
				},
				shop_list: [],
				ruleForm2: {
					shop_id: "",
					btime: this.$moment().format('YYYY-MM-DD'),
					etime: this.$moment().format('YYYY-MM-DD'),
				},
				rules: {
					shop_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
				},
			}
		},

		inject: ['appdata', 'oncopy'],

		computed: {
			btimePickerOptions() {
				var etime = this.ruleForm2.etime
				return {
					disabledDate: function(time) {
						if (time.getTime() > Date.now()) {
							return true
						}
						if (etime) {
							var t = this.$moment(etime)
							return time.getTime() > t.valueOf()
								|| time.getTime() < t.clone().subtract(15, 'days').valueOf()
						}
						return false
					}.bind(this),
				}
			},
			etimePickerOptions() {
				var btime = this.ruleForm2.btime
				return {
					disabledDate: function(time) {
						if (time.getTime() > Date.now()) {
							return true
						}
						if (btime) {
							var t = this.$moment(btime)
							return time.getTime() < t.valueOf()
								|| time.getTime() > t.clone().add(15, 'days').valueOf()
						}
						return false
					}.bind(this),
				}
			},
			mallNameColumnWidth() {
				return this.calcColumnWidthByField('mall_name', 4, 14, 120, 280)
			},
			afterSaleIdColumnWidth() {
				return this.calcColumnWidthByField('after_sale_id', 4, 10, 120, 220)
			},
			orderSnColumnWidth() {
				var padding = 28
				var headerW = 4 * 14 + padding
				var maxContentW = 0
				var list = this.list || []
				for (var i = 0; i < list.length; i++) {
					var orderSn = list[i] && list[i].order_sn != null ? String(list[i].order_sn) : ''
					if (!orderSn) {
						continue
					}
					var w = 0
					for (var j = 0; j < orderSn.length; j++) {
						var code = orderSn.charCodeAt(j)
						w += code > 255 ? 14 : 8.2
					}
					if (w > maxContentW) {
						maxContentW = w
					}
				}
				var width = Math.ceil(Math.max(headerW, maxContentW + padding))
				if (width < 72) {
					return 72
				}
				if (width > 320) {
					return 320
				}
				return width
			},
			afterSalesStatusColumnWidth() {
				return this.calcColumnWidthByField('after_sales_status_str', 4, 14, 72, 180)
			},
			afterSalesTypeColumnWidth() {
				return this.calcColumnWidthByField('after_sales_type_str', 4, 14, 72, 160)
			},
			disputeRefundColumnWidth() {
				return this.calcColumnWidthByField('dispute_refund_status', 4, 14, 72, 140)
			},
			speedRefundColumnWidth() {
				return this.calcColumnWidthByField('speed_refund_flag', 4, 14, 72, 120)
			},
			shippingNameColumnWidth() {
				return this.calcColumnWidthByField('shipping_name', 4, 14, 72, 200)
			},
			trackingNumberColumnWidth() {
				return this.calcColumnWidthByField('tracking_number', 5, 10, 100, 220)
			},
			createTimeColumnWidth() {
				return this.calcColumnWidthByField('create_time_str', 6, 10, 100, 180)
			},
			updateTimeColumnWidth() {
				return this.calcColumnWidthByField('update_time_str', 4, 10, 100, 180)
			}
		},

		mounted() {
			this.onshop();
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			calcColumnWidthByField(field, headerLen, charWidth, minW, maxW) {
				var maxLen = headerLen || 4
				var list = this.list || []
				for (var i = 0; i < list.length; i++) {
					var text = list[i] && list[i][field] != null ? String(list[i][field]) : ''
					if (text.length > maxLen) {
						maxLen = text.length
					}
				}
				var width = maxLen * (charWidth || 14) + 24
				if (width < minW) {
					return minW
				}
				if (width > maxW) {
					return maxW
				}
				return width
			},
			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					order_sn: "",
					after_sale_id: "",
					after_sales_status: "",
					after_sales_type: "",
					platform_order_status: ""
				};
				this.page = 1;
				this.onlist();
			},

			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onshop() {
				var obj = {
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/retail_shop/list', obj).then(res => {
					if (res.data.code == 0) {
						this.shop_list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/after_sale/list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onservice(trade_no) {
				const url = this.$router.resolve({
					path: '/buyer/order/order',
					query: {
						trade_no: trade_no
					}
				});
				window.open(url.href, "_blank");
			},

			onsyncorder() {
				if (this.shop_list.length > 0) {
					this.ruleForm2.shop_id = this.shop_list[0].id
				}
				this.show = true
			},

			onclose4() {
				this.show = false
				this.ruleForm2 = {
					shop_id: "",
					btime: this.$moment().format('YYYY-MM-DD'),
					etime: this.$moment().format('YYYY-MM-DD'),
				}
			},

			onsubxz() {
				this.$refs['ruleForm2'].validate((valid) => {
					if (!valid) {
						return
					}
					if (!this.ruleForm2.btime || !this.ruleForm2.etime) {
						this.$message.warning('请选择开始日期和结束日期')
						return
					}
					var diff = this.$moment(this.ruleForm2.etime).diff(
						this.$moment(this.ruleForm2.btime), 'days'
					)
					if (diff < 0) {
						this.$message.warning('结束日期不能早于开始日期')
						return
					}
					if (diff > 15) {
						this.$message.warning('日期跨度不能超过15天')
						return
					}
					var obj = {
						shop_id: this.ruleForm2.shop_id,
						btime: this.ruleForm2.btime,
						etime: this.ruleForm2.etime,
					}
					this.$axios.post('api/after_sale/download', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功')
							this.onclose4()
							this.onlist()
						} else {
							this.$message.error(res.data.message)
						}
					}).catch(err => {
						console.log(err)
					})
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.service {
		height: 100%;
		padding: 10px 10px 0 0;
		background-color: #fff;
		box-sizing: border-box;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.img {
		width: 100px;

		img {
			width: 100%;
		}
	}

	.mall-name-text,
	.adapt-text {
		line-height: 1.35;
		word-break: break-all;
		white-space: normal;
	}

	.order-sn-text {
		line-height: 1.35;
		white-space: nowrap;
	}

	/deep/ td.mall-name-column .cell,
	/deep/ td.adapt-text-column .cell {
		white-space: normal;
	}

	/deep/ th.order-sn-column .cell,
	/deep/ td.order-sn-column .cell {
		white-space: nowrap;
		padding-left: 10px;
		padding-right: 10px;
	}

	.goods-name-cell {
		width: 15em;
		margin: 0 auto;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
		cursor: pointer;
	}

	.goods-name-empty {
		color: #909399;
	}

	/deep/ td.goods-name-column .cell {
		overflow: hidden;
	}

	.header-wrap-3 {
		width: 3em;
		margin: 0 auto;
		line-height: 1.3;
		word-break: break-all;
		white-space: normal;
	}

	/deep/ th.platform-order-status-column .cell,
	/deep/ td.platform-order-status-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}
	
	/deep/ .item .el-select {
		width: 300px;
	}

	/deep/ .item .el-date-editor {
		width: 300px;
	}
	
	/deep/ .myradio .el-radio__label {
		display: none;
	}
</style>

<style lang="less">
.goods-name-popover__content {
	max-height: 200px;
	overflow-y: auto;
	word-break: break-all;
	line-height: 1.5;
	margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/pdd/service.vue